// src/components/common/ConfirmDialogHeader.js
//
// ConfirmDialog's title row — a plain heading, or an icon + heading for
// danger/security confirms with a leadingIcon. Extracted alongside
// ConfirmDialogBody (Task 2 · WAVE 1 · ENGINE, 2026-09-24) to keep the parent
// under the 500-line cap once the checking-state plumbing landed — zero
// behavior change, same markup/tokens verbatim.

import { foundation } from '../../ui/tokens';
import { overlayTitle } from '../../ui/overlayStyles';

const { color, spacePx } = foundation;

const titleRowWithIconStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: spacePx[2],
  marginBottom: spacePx[2],
  flexShrink: 0,
};

export default function ConfirmDialogHeader({ leadingIcon, tone, title, titleStyle, morphTitleGutter }) {
  if (leadingIcon) {
    return (
      <div style={{ ...titleRowWithIconStyle, ...morphTitleGutter }}>
        <span
          aria-hidden
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0,
            color: tone === 'danger' ? color.semantic.danger : color.neutral.textSecondary,
          }}
        >
          {leadingIcon}
        </span>
        <h3 style={{ ...overlayTitle, margin: 0 }}>{title}</h3>
      </div>
    );
  }
  return <h3 style={{ ...titleStyle, ...morphTitleGutter }}>{title}</h3>;
}
